import { useMemo } from 'react';
import PhotoSize from '@alltrails/types/PhotoSize';
import PhotoSizeDimensions from '@alltrails/types/PhotoSizeDimensions';
import StaticMapSize from '@alltrails/types/StaticMapSize';
import { getTrailProfilePhoto } from '../utils/photoRequests';
import useCardPhotos from './useCardPhotos';

const photoSizeToDimensions = (photoSize: PhotoSize): PhotoSizeDimensions => {
  switch (photoSize) {
    case PhotoSize.Icon:
      return '50x50';
    case PhotoSize.SmallSquare:
      return '80x80';
    case PhotoSize.MediumSquare:
      return '120x120';
    case PhotoSize.LargeSquare:
      return '160x160';
    case PhotoSize.SmallWide:
      return '160x120';
    case PhotoSize.LargeWide:
      return '800x300';
    case PhotoSize.LargerWide:
      return '1080x700';
    case PhotoSize.Small:
      return '100x100';
    case PhotoSize.Medium:
      return '200x200';
    case PhotoSize.Large:
      return '500x500';
    case PhotoSize.ExtraLarge:
      return '2048x2048';
    default:
      return '500x500';
  }
};

const useTrailPhotos = (id: number, hasProfilePhoto: boolean, size: PhotoSize, mapSize: StaticMapSize, maxPhotos: number, baseUrl?: string) => {
  const { photos: cardPhotos, loadPhotos } = useCardPhotos({
    cardType: 'trails',
    id,
    size: photoSizeToDimensions(size),
    maxPhotos: hasProfilePhoto ? maxPhotos : maxPhotos - 1,
    baseUrl
  });

  const photos = useMemo(
    // If the trail has a profile photo, it will be returned first already by useCardPhotos.
    // If not, fetch the static map directly as the fallback profile photo.
    () => (hasProfilePhoto ? cardPhotos : [getTrailProfilePhoto(id, size, mapSize, baseUrl), ...cardPhotos]),
    [baseUrl, cardPhotos, hasProfilePhoto, id, size, mapSize]
  );

  return useMemo(() => ({ photos, loadPhotos }), [loadPhotos, photos]);
};

export default useTrailPhotos;
